import { render, staticRenderFns } from "./bulk-actions.vue?vue&type=template&id=0fa8f10a&scoped=true&"
import script from "./bulk-actions.vue?vue&type=script&lang=js&"
export * from "./bulk-actions.vue?vue&type=script&lang=js&"
import style0 from "./bulk-actions.vue?vue&type=style&index=0&id=0fa8f10a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8f10a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa8f10a')) {
      api.createRecord('0fa8f10a', component.options)
    } else {
      api.reload('0fa8f10a', component.options)
    }
    module.hot.accept("./bulk-actions.vue?vue&type=template&id=0fa8f10a&scoped=true&", function () {
      api.rerender('0fa8f10a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/grid-components/bulk-actions.vue"
export default component.exports